import {  Alert, Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Trash01 ,Plus } from '../../../assets';
import { useContext } from 'react';
import { StockCountCreateContext, StockCountCreateValues } from '../contexts/StockCountCreateContext';

const StockCountProductTypes = () => {
  const { t,
    deleteProductType,
    handleProductTypeClickOpen,
    deleteProductTypeRow,
    countZonesData,
    productTypeData } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const hasProductTypes = productTypeData.length > 0;
  const hasCountZonesWithItems = (countZonesData.length > 0 && countZonesData.every(z => (z.numberOfItems ?? 0) > 0));

  return (
    <Box sx={{ border:'1px solid' }}>
      <Grid container
        sx={{ pt: '12px', pb: '6px', px: '8px' }}>
        <Grid item 
          xs={6}>
          <Typography variant="textMD"
            sx={{ fontWeight:'bold' }}>{t('types')}</Typography>
        </Grid>
        <Grid item 
          xs={6}
          sx={{ display:'flex', justifyContent:'flex-end',alignItems:'center' }}>
          {hasProductTypes && (
            <Button
              size='lg'
              sx={{ mr: 4 }}
              variant='bad'
              onClick={deleteProductType}
            ><Trash01 />{t('deleteAll')}
            </Button>
          )}
          <Button
            size='lg'
            variant='primary'
            disabled={hasCountZonesWithItems}
            onClick={handleProductTypeClickOpen}><Plus/>{t('add')}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ pt:'10px' }}>
        {hasProductTypes ? (
          <TableContainer sx={{ overflowy:'auto' }}>
            <Table>
              <TableHead  >
                <TableRow>
                  <TableCell >{t('type')}</TableCell>
                  <TableCell 
                    style={{ display:'flex', justifyContent:'flex-end' }} >{t('remove')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productTypeData?.map((row) => (
                  <TableRow
                    key={row}
                  >
                    <TableCell >
                      {t(row.toLowerCase())}
                    </TableCell>
                    <TableCell style ={{ display:'flex', justifyContent:'flex-end' }} ><Trash01 style={{ color:'red' }}
                      onClick={() => deleteProductTypeRow(row)}/></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) :(
          <Alert severity='info'
            variant= {'outlined'}
            sx={{ mb: '12px', mx: '8px' }}>
            {hasCountZonesWithItems ? t('zoneAdditionalTypes') : t('noTypes')}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default StockCountProductTypes;